<template>
    <div class="login-page">
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-md-6 col-sm-8 mx-auto">
                    <div class="card login">
                    <h1>Sign In</h1>
                    <form class="form-group">
                        <input v-model="credentials.userEmail" type="email" class="form-control" placeholder="Email" required><br>
                        <input v-model="credentials.userPassword" type="password" class="form-control" placeholder="Password" required><br>
                        <input type="submit" class="submit btn btn-success btn-lg btn-block" @click="loginUSer">
                    </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'UserLogin',
    data() {
        return {
            credentials: {
                userEmail: "",
                userPassword: "",
            },
        }
    },
    methods: {
        loginUSer(e) {
            e.preventDefault()
            if (this.credentials.userEmail === "" || this.credentials.userPassword === "") {
                alert("Please fill out all fields")
            } else {
                axios
                .post(this.$apiUrl + 'login', this.credentials)
                .then(res => {
                    if(res.data.status == 200) {
                        localStorage.setItem('token', res.data.token)
                        localStorage.setItem('authId', res.data.authId)
                        this.$router.push('/features')
                    }
                    if (res.data.msg) {
                        alert(res.data.msg)
                    }
                })
                .catch(error => {
                    console.log(error)
                    this.$router.push('/login')
                    alert('Unable to sign in. Please try again later.')
                })
                .finally(() => {
                })

            }
        },
    }
}
</script>


<style scoped>
/* p {
   line-height: 1rem;
} */
.card {
   padding: 20px;
   border: none;
}
.login-page {
   align-items: center;
   padding-top: 100px;
}
.submit {
    width: 100%;
}
</style>